<ng-container *ngIf="loading; else content">
  <app-loader text="Моля изчакайте..."></app-loader>
</ng-container>

<ng-template #content>
  <app-modal [padding]="'lg'">

      <app-modal-header
        [showCloseButton]="true"
        [title]="'Информация за аварията'"
        [centerTitle]="true" (closed)="closeModal()">
      </app-modal-header>

      <app-modal-body>

        <section class="row">
          <h4>Информация за аварията</h4>
          <div class="col">
            <div class="row pt-3">
              <div class="col mb-4">
                <app-label-value-lozenge [label]="'Идентификатор'" [value]="emergencyId">
                </app-label-value-lozenge>
              </div>
              <div class="col mb-4">
                <app-label-value-lozenge [label]="'Име'" [value]="emergencyTitle">
                </app-label-value-lozenge>
              </div>
              <div class="col mb-4">
                <app-label-value-lozenge [label]="'Тип на аварията'" [value]="emergencyType">
                </app-label-value-lozenge>
              </div>
              <div class="col mb-12">
                <app-label-value-lozenge [label]="'Статус на Авария'" [value]="emergency.emergencyStatus.title">
                </app-label-value-lozenge>
              </div>
              <div class="col-12">
                <app-label-value-lozenge [label]="'Описание на аварията'" [value]="emergencyDescription">
                </app-label-value-lozenge>
              </div>
            </div>
          </div>
        </section>

        <hr class="mt-4 mb-4" />
        <section class="row">
          <h4>Организиране на физическа проверка</h4>
          <div class="col">
            <div class="row pt-3">
              <div class="col mb-4">
                <app-label-value-lozenge [label]="'Ремонта група'" [value]="workingGroup">
                </app-label-value-lozenge>
              </div>
              <div class="col mb-4">
                <app-label-value-lozenge [label]="'Мениджър на ремонта група'" [value]="workingGroupManager">
                </app-label-value-lozenge>
              </div>
            </div>
          </div>
        </section>

        <hr class="mt-4 mb-4" />
        <section class="row">
          <h4>Местоположение на аварията</h4>
          <div class="col-12">
            <div class="map-container-wrapper mb-3">
              <app-map-location-selector [readonly]="true"
                                         [location]="emergencyLocation"
                                         [zoom]="16">
              </app-map-location-selector>
            </div>
          </div>
        </section>

      </app-modal-body>

      <app-modal-footer>
        <div class="footer-wrapper">
          <button class="btn btn-primary" (click)="closeModal()">Затвори</button>
        </div>
      </app-modal-footer>

  </app-modal>
</ng-template>
